import { render, staticRenderFns } from "./CarWash.vue?vue&type=template&id=253db6f0"
import script from "./CarWash.vue?vue&type=script&lang=js"
export * from "./CarWash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports